import axios from 'axios';
import { createAuthHeaders } from '../../api-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export interface CacheTtlOverride {
  ttl: number;
  updatedAt: number;
  updatedBy: string;
}

export interface CacheTtlStatus {
  path: string;
  override: CacheTtlOverride | null;
  defaultTtl: number;
  effectiveTtl: number;
}

/**
 * Per-endpoint Cache TTL overrides for an OptiDev Cloud project.
 * Backend signs + proxies to the gateway worker's admin endpoint; the
 * browser never talks to the gateway admin endpoint directly.
 */
export const cacheTtlApi = {
  /** Read the current override + effective TTL for an edge-function path. */
  async getStatus(token: string, projectId: string, path: string): Promise<CacheTtlStatus> {
    const response = await axios.get(
      `${API_URL}/api/supabase/projects/${projectId}/cache-ttl`,
      {
        headers: createAuthHeaders(token),
        params: { path },
      },
    );
    return response.data;
  },

  /** Set / update the override (seconds, 1..86400). */
  async setOverride(
    token: string,
    projectId: string,
    path: string,
    ttl: number,
  ): Promise<void> {
    await axios.post(
      `${API_URL}/api/supabase/projects/${projectId}/cache-ttl`,
      { path, ttl },
      {
        headers: createAuthHeaders(token),
      },
    );
  },

  /** Remove the override (revert to gateway default). */
  async deleteOverride(token: string, projectId: string, path: string): Promise<void> {
    await axios.delete(
      `${API_URL}/api/supabase/projects/${projectId}/cache-ttl`,
      {
        headers: createAuthHeaders(token),
        data: { path },
      },
    );
  },
};
